import React, { useState, useEffect, useContext, useMemo, useRef, useLayoutEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import NoIndex from "../NoIndex";
import { X, Eye, Pencil, Plus, Layers, Package, PackageCheck, Info } from "lucide-react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Modal } from "react-bootstrap";
import CatalogueItemModal from "./Catalogue Components/CatalogueItemModal";
import VariantManagerModal from "./Catalogue Components/VariantManagerModal";
import CatalogueCustomizationModal from "./Catalogue Components/CatalogueCustomizationModal";
import { OverlayTrigger, Popover } from "react-bootstrap";
import AddPrinterModal from "./Catalogue Components/AddPrinterModal";
import rightArrow from "../../images/Arrow - Right.svg";
import downArrow from "../../images/Arrow - Down.svg";
import "./CatalogueTable.css";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
import { useNavigate } from "react-router-dom";
import AddItemVariantModal from "./Catalogue Components/AddItemVariantModal";
import VariantStockVisibilityModal from "./Catalogue Components/VariantStockVisibilityModal";






// Predefined customization sets
const customizationSets = [
  {
    customize_field: "Sweetness",
    options: ["Less Sweet", "Sweet", "High Sweet"],
  },
  {
    customize_field: "Spice Level",
    options: ["Mild", "Medium", "Spicy"],
  },
  {
    customize_field: "Oil Preference",
    options: ["Low Oil", "Normal Oil", "Extra Oil"],
  },
  {
    customize_field: "Butter Topping",
    options: ["No Butter", "Butter", "Extra Butter"],
  },
  {
    customize_field: "Cooking Type",
    options: ["Fried", "Grilled", "Steamed"],
  },
  {
    customize_field: "Onion & Garlic",
    options: ["No Onion", "No Garlic"],
  },
];

const CatalogueTable = ({ userID }) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [loading, setLoading] = useState(false);
  const [catalogueStore, setCatalogueStore] = useState([]);

  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("catalogue");

  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);


  const [expandedCategories, setExpandedCategories] = useState([]);

  const [loadingVariants, setLoadingVariants] = useState(false);
  const [variants, setVariants] = useState([]);

  const [customizationModal, setCustomizationModal] = useState(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [preSelectedCustomizaton, setPreSelectedCustomizaton] = useState(null);
  const [isItemPackagingEnabled, setIsItemPackagingEnabled] = useState(false);

  const [selectedCustomizations, setSelectedCustomizations] = useState([]);
  const [availabilityData, setAvailabilityData] = useState({});
  const [viewModalItem, setViewModalItem] = useState(null);
  const [viewModalTab, setViewModalTab] = useState("details");
  const [printerList, setPrinterList] = useState([]);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState(null);
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [editableDetails, setEditableDetails] = useState({});
  const [showAddItemVariantModal, setShowAddItemVariantModal] = useState(false);
  const [selectedVariantItem, setSelectedVariantItem] = useState(null);
  const [variantSVModalOpen, setVariantSVModalOpen] = useState(false);
  const [variantSVItem, setVariantSVItem] = useState(null);

  const [packagingBusyId, setPackagingBusyId] = useState(null);

  const anchorRef = useRef(null);
  // anchorRef.current = { catId: "353", itemId: "16086" }

  const markAnchor = (catId, itemId) => {
    anchorRef.current = { catId: String(catId), itemId: String(itemId) };
  };

  const didSetDefaultOpenRef = useRef(true);


  // Prevent number inputs from changing on scroll (trackpad / mouse wheel)
  const handleNumberWheel = (e) => {
    e.target.blur();
  };
  const handleItemUpdated = () => {
    allcatalogueAPI(true);
  };

  const handleCheckboxChange = (itemId, field) => {
    setAvailabilityData((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [field]: !prev[itemId][field],
      },
    }));
  };

  const handleSubmit = async (e, itemId) => {
    e.preventDefault();
    const updated = availabilityData[itemId];

    try {
      const requestBody = {
        userid: userID,
        itemId: itemId,
        homeDelivery: updated.homeDelivery,
        takeaway: updated.takeaway,
        dining: updated.dineIn,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/changeItemAvailability`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Status updated successfully!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };

  const allcatalogueAPI = async (preserveScroll = false) => {
    const currentScrollY = preserveScroll ? window.scrollY || 0 : null;

    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogueItemsMaster`,
        requestBody,
        config
      );
      console.log(response.data.response);
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
      if (preserveScroll && currentScrollY !== null) {
        window.scrollTo({ top: currentScrollY, behavior: "auto" });
      }
    }
  };
  // Refresh catalogue but keep current scroll position
  const refreshCataloguePreserveScroll = async () => {
    const currentScrollY = window.scrollY || 0;
    await allcatalogueAPI();
    window.scrollTo({ top: currentScrollY, behavior: "auto" });
  };
  const getPackagingChargesAndTriggersApi = async () => {
    try {
      const resp = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPackagingChargesAndTriggers`,
        { userid: userID },
        config
      );

      if (resp?.data?.responseCode === "00") {
        const row = resp?.data?.response?.[0];

        // single boolean state
        setIsItemPackagingEnabled(row?.packagingItemWise === "Y");
      }
    } catch (err) {
      console.error("Failed to fetch packaging config");
    }
  };



  useEffect(() => {
    allcatalogueAPI();
    fetchVariants();
    getPackagingChargesAndTriggersApi();
  }, []);
  const fetchVariants = async () => {
    setLoadingVariants(true);
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
      };
      const response = await axios.post(
        `${baseUrl}/api/Inventory/v1.0/getAllInventoryVariant`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const list = (response.data.response || []).map((r) => ({
          id: String(r.pk_variant_id ?? r.variantId ?? r._id ?? ""),
          variant_title: r.variant_title ?? r.variantTitle ?? "",
          category: r.category ?? "",
        }));
        setVariants(list);
      } else {
        setVariants([]);
      }
    } catch {
      setVariants([]);
    } finally {
      setLoadingVariants(false);
    }
  };


  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
  // Filter the catalogue based on search term
  const filteredCatalogue = catalogueStore.filter((item) =>
    searchTerm.trim() === "" // If search box is empty, show full list
      ? true
      : item.title?.toLowerCase().includes(searchTerm.toLowerCase()) // Case-insensitive filter
  );



  const toggleCategory = (catId) => {
    setExpandedCategories((prev) =>
      prev.includes(catId) ? prev.filter((id) => id !== catId) : [...prev, catId]
    );
  };

  const filteredCategories = useMemo(() => {
    if (!catalogueStore) return [];
    return catalogueStore
      .map((category) => {
        const filteredItems = (category.menu_items || []).filter((item) => {
          const matchesSearch = item?.item_name
            ?.toLowerCase()
            .includes(searchText.toLowerCase());
          if (!matchesSearch) return false;

          const prices = Array.isArray(item.prices) ? item.prices : [];
          const firstPrice = prices.length > 0 ? prices[0] : {};
          const visibilitySource =
            item.visibility ?? firstPrice.visibility;

          const isVisible =
            visibilitySource === "Y" ||
            visibilitySource === true ||
            visibilitySource === 1 ||
            visibilitySource === "1";

          const isOutOfStockOrInvisible = !item.inStock || !isVisible;

          if (activeTab === "out-of-stock") {
            return isOutOfStockOrInvisible;
          }

          // activeTab === "catalogue" -> show all items (matching search) regardless of stock/visibility
          return true;
        });

        return {
          ...category,
          menu_items: filteredItems,
        };
      })
      .filter((category) => category.menu_items.length > 0);
  }, [catalogueStore, searchText, activeTab]);

  useEffect(() => {
    // If anchor restore is pending, don't fight it
    if (anchorRef.current) return;

    // If searching: expand only matched categories
    if (searchText.trim()) {
      const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
      setExpandedCategories(matchedIds);
      return;
    }

    // No search: set default open only ONCE after first load
    if (!didSetDefaultOpenRef.current && catalogueStore.length > 0) {
      didSetDefaultOpenRef.current = true;
      const firstCatId = String(catalogueStore[0].cat_id);
      setExpandedCategories([firstCatId]);
    }
  }, [filteredCategories, searchText, catalogueStore]);

  const toggleStockStatus = async (item) => {
    const newStatus = item.inStock ? "N" : "Y";

    const prices = Array.isArray(item.prices) ? item.prices : [];
    const firstPrice = prices.length > 0 ? prices[0] : {};
    const visibilitySource = item.visibility ?? firstPrice.visibility;

    const isVisible =
      visibilitySource === "Y" ||
      visibilitySource === true ||
      visibilitySource === 1 ||
      visibilitySource === "1";

    try {
      const requestBody = {
        userid: userID,
        id: item.item_id,
        stock: "1",
        inStock: newStatus,
        isVisible: isVisible ? "Y" : "N",
        type: "item",
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateStock`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Status updated successfully!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };


  // Open customization modal for an item
  const openCustomizationModal = (item, preSelected) => {
    setSelectedCategoryId(item);
    setCustomizationModal(true);

    // Parse preSelected (it could be a string or object)
    let parsed = [];
    try {
      if (typeof preSelected === "string") {
        parsed = JSON.parse(preSelected || "[]");
      } else if (Array.isArray(preSelected)) {
        parsed = preSelected;
      }
    } catch (err) {
      console.error("Failed to parse preSelected customizations:", err);
    }

    setPreSelectedCustomizaton(parsed);

    // Extract only the customize_field names for pre-checking
    const initiallySelectedFields = parsed.map((c) => c.customize_field);
    setSelectedCustomizations(initiallySelectedFields);
  };

  const handleCustomizationApply = async () => {
    const categoryId = selectedCategoryId; // currently selected category ID

    // selectedCustomizations is now an array of customize_field names, not indexes
    const customizationArray = customizationSets
      .filter((set) => selectedCustomizations.includes(set.customize_field))
      .map((set) => ({
        customization_type: "customize",
        customize_field: set.customize_field,
        options: set.options,
      }));

    const payload = {
      userid: userID,
      id: categoryId,
      customizations: customizationArray,
      type: "category",
      operation: "add",
    };

    try {
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCustomization`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        toast.success(
          res.data.data.message || "Customization updated successfully"
        );
        await allcatalogueAPI();
      }
      else {
        toast.error(res.data.data.message || "Failed to update customization");
      }
    } catch (err) {
      console.error("Failed to send customization:", err);
      toast.error("Something went wrong while updating customization");
    }

    setCustomizationModal(false);
  };

  const [addPrinterModalOpen, setAddPrinterModalOpen] = useState(false);
  const [addPrinterFormData, setAddPrinterFormData] = useState({
    printerName: "",
    printerAlias: "",
    deviceName: "",
    deviceNumber: "",
  });

  const handlePrinterInputChange = (e) => {
    setAddPrinterFormData({
      ...addPrinterFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddPrinterSubmit = async () => {
    const payload = {
      userid: String(userID),
      ...addPrinterFormData,
    };

    try {
      const res = await fetch(`${baseUrl}/api/Order/v1.0/addPrinter`, {
        method: "POST",
        headers: {
          ...config.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.responseCode === "00") {
        Swal.fire("Success", data.responseMessage, "success");
        setAddPrinterModalOpen(false);
        setAddPrinterFormData({
          printerName: "",
          printerAlias: "",
          deviceName: "",
          deviceNumber: "",
        });
      } else {
        Swal.fire("Error", data.responseMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const fetchPrinterList = async () => {
    try {
      setPrinterLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPrinters`,
        {
          userid: userID,
        },
        config
      );

      if (res.data.responseCode === "00") {
        setPrinterList(res.data.response || []);
      } else {
        toast.error("Failed to load printers");
      }
    } catch (err) {
      // toast.error("Error fetching printers");
    } finally {
      setPrinterLoading(false);
    }
  };

  const handleSavePrinterToItem = async () => {
    if (!selectedPrinter) return toast.error("Please select a printer first");

    try {
      const payload = {
        userid: userID,
        itemId: viewModalItem.item_id,
        printerCode: selectedPrinter?.printerCode,
        printerAlias: selectedPrinter?.printerAlias,
      };

      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/addPrinterCodeToItem`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        Swal.fire("Success", res.data.responseMessage, "success");
      } else {
        Swal.fire("Error", res.data.responseMessage, "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };


  const handleUpdateItem = async () => {
    try {
      const payload = {
        userid: String(userID),
        itemId: editableDetails.item_id,
        itemName: editableDetails.item_name,
        sizeId: String(editableDetails.sizeId || ""),
        category: String(editableDetails.category || ""),
        size: String(editableDetails.size || ""),
        sellingPrice: String(editableDetails.sellingPrice || ""),
        // NEW extended fields
        homeDeliveryPrice: String(editableDetails.homeDeliveryPrice ?? ""),
        takewayPrice: String(editableDetails.takewayPrice ?? ""),
        diningPrice: String(editableDetails.diningPrice ?? ""),
        roomOrderPrice: String(editableDetails.roomOrderPrice ?? ""),
        carOrderPrice: String(editableDetails.carOrderPrice ?? ""),
        taxPercentage: String(editableDetails.taxPercentage ?? ""),
      };

      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCatalogItems`,
        payload,
        config
      );

      if (res.data.responseCode === "00") {
        toast.success(
          res.data.responseMessage || "Item updated successfully"
        );
        setIsEditingDetails(false);
        await allcatalogueAPI(true); // 🔹 preserve scroll & open category
        await allcatalogueAPI();
      } else {
        Swal.fire(
          "Error",
          res.data.responseMessage || "Update failed",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const toggleVisibilityStatus = async (item) => {
    const prices = Array.isArray(item.prices) ? item.prices : [];
    const firstPrice = prices.length > 0 ? prices[0] : {};
    const visibilitySource = item.visibility ?? firstPrice.visibility;

    const isCurrentlyVisible =
      visibilitySource === "Y" ||
      visibilitySource === true ||
      visibilitySource === 1 ||
      visibilitySource === "1";

    const newVisibility = isCurrentlyVisible ? "N" : "Y";
    const currentInStockYN = item.inStock ? "Y" : "N";

    try {
      const requestBody = {
        userid: userID,
        id: item.item_id,
        type: "item",
        stock: "1",
        inStock: currentInStockYN,
        isVisible: newVisibility,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateStock`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Visibility updated!"
        );
        await allcatalogueAPI();
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.responseMessage || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };

  const ResetStock = async () => {
    try {
      setPrinterLoading(true);
      const res = await axios.post(
        `${baseUrl}/api/Order/v1.0/resetStock`,
        {
          userid: userID,
        },
        config
      );

      if (res.data.responseCode === "00") {
        setPrinterList(res.data.response || []);
        toast.success(res.data.responseMessage)
      } else {
        toast.error("Failed to load printers");
      }
    } catch (err) {
      toast.error("Error fetching printers");
    } finally {
      setPrinterLoading(false);
    }
  };
  const togglePackagingCharge = async (item) => {
    if (!item?.item_id) return;

    const current = String(item.packaging_charge || "N").toUpperCase(); // "Y" or "N"
    const next = current === "Y" ? "N" : "Y";

    const payload = {
      usCode: String(userID),          // userId
      itemId: String(item.item_id),
      trigger: next,                   // "Y" or "N"
    };

    setPackagingBusyId(String(item.item_id));

    try {
      const res = await axios.post(
        `${baseUrl}/api/Order/EnableDisablePackagingCharges`,
        payload,
        config
      );

      if (res?.data?.responseCode === "00") {
        Swal.fire("Success", res.data.responseMessage || "Updated", "success");
        // refresh list to get latest packaging_charge from getCatalogueItemsMaster
        refreshCataloguePreserveScroll();
      } else {
        Swal.fire("Error", res?.data?.responseMessage || "Failed", "error");
      }
    } catch (e) {
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setPackagingBusyId(null);
    }
  };
  useLayoutEffect(() => {
    const anchor = anchorRef.current;
    if (!anchor) return;

    // 1) Make sure the category is expanded
    setExpandedCategories((prev) => {
      const catId = anchor.catId;
      return prev.includes(catId) ? prev : [...prev, catId];
    });

    // 2) Scroll to the item after DOM is painted
    requestAnimationFrame(() => {
      const el = document.getElementById(`cat-item-${anchor.itemId}`);
      if (el) {
        el.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });

    // 3) Clear anchor so it doesn't keep scrolling forever
    anchorRef.current = null;
  }, [catalogueStore]);
  useEffect(() => {
    if (!catalogueStore?.length) return;

    setAvailabilityData((prev) => {
      const next = { ...prev };

      for (const category of catalogueStore) {
        for (const item of (category.menu_items || [])) {
          if (!next[item.item_id]) {
            next[item.item_id] = {
              homeDelivery: item.homeDeliveryAvailability,
              takeaway: item.takeawayAvailability,
              dineIn: item.diningAvailability,
            };
          }
        }
      }

      return next;
    });
  }, [catalogueStore]);
  const iconLegendPopover = (
    <Popover id="catalogue-icon-legend" style={{ minWidth: 380 }}>
      <Popover.Header as="h3" className="fw-bold">
        Icons Guide
      </Popover.Header>
      <Popover.Body>
        <div className="d-flex flex-column gap-2">

          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, borderRadius: "50%", background: "#16a34a", color: "#fff" }}
            >
              <Eye size={14} />
            </span>
            <div className="small">
              <b>View</b> — open item details and edit details/price/avalaible.
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, borderRadius: "50%", background: "#01C37D", color: "#fff" }}
            >
              <Plus size={14} />
            </span>
            <div className="small">
              <b>Add Variant</b> — create a new variant for the item
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, borderRadius: "50%", background: "#2563eb", color: "#fff" }}
            >
              <Layers size={14} />
            </span>
            <div className="small">
              <b>Manage Variants</b> — update variant visibility/stock
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, borderRadius: "50%", background: "#ef4444", color: "#fff" }}
            >
              <Package size={14} />
            </span>
            <div className="small">
              <b>Packaging OFF</b> — packaging charges disabled
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{ width: 28, height: 28, borderRadius: "50%", background: "#16a34a", color: "#fff" }}
            >
              <PackageCheck size={14} />
            </span>
            <div className="small">
              <b>Packaging ON</b> — packaging charges enabled
            </div>
          </div>

          <div className="small text-muted mt-2">
            Checkboxes:
            <div>• <b>Visible</b> — show/hide item</div>
            <div>• <b>Stock</b> — in stock / out of stock</div>
          </div>

        </div>
      </Popover.Body>
    </Popover>
  );




  return (
    <>
      <>
        <NoIndex />
        <div className="d-flex justify-content-center text-center">
          <ToastContainer />
        </div>
        <div
          className="p-4 bg-white"
          style={{
            fontFamily: "Nunito, sans-serif",
          }}
        >


          <div className="bg-white px-4">
            <div className="  " style={{ borderRadius: "10px" }}>
              <div className="d-flex justify-content-between pb-2">
                <div className="CreateCampaign p-0 m-0">Catalogue Items </div>
                <div className="d-flex justify-content-between">
                  <Form className="">
                    <FormControl
                      type="text"
                      placeholder="Search"
                      className="bg-light"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </Form>
                  <div></div>
                  <div>
                    <button
                      className="btn btn-primary single-line-css ms-3"
                      onClick={() => navigate("/Orders/Catalogue/add-items")}
                    >
                      Add Items
                    </button>

                    <button
                      className="btn btn-success single-line-css ms-3"
                      onClick={() => setIsVariantModalOpen(true)}
                    >
                      Add Varients
                    </button>

                    {/* <button
                      className="blue-button single-line-css ms-3"
                      onClick={() => setAddPrinterModalOpen(true)}
                    >
                      Add Printer
                    </button> */}

                    <button
                      className="btn btn-danger single-line-css ms-3"
                      onClick={() => ResetStock()}
                    >
                      Reset Stock
                    </button>
                  </div>

                </div>
              </div>

              <div className="mt-3">
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Catalogue tabs"
                >
                  <button
                    type="button"
                    className={`btn btn-sm ${activeTab === "catalogue"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setActiveTab("catalogue")}
                  >
                    Catalogue
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${activeTab === "out-of-stock"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setActiveTab("out-of-stock")}
                  >
                    Out of Stock
                  </button>
                  <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={iconLegendPopover}>
                    <button
                      type="button"
                      className="btn btn-sm d-flex ms-1 align-items-center justify-content-center"
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        border: "1px solid #d0d5dd",
                        background: "#fff",
                        color: "#344054",
                      }}
                      title="Icons Guide"
                    >
                      <Info size={16} />
                    </button>
                  </OverlayTrigger>
                </div>

              </div>

              {loading ? (
                <div className=" m-5 p-5 d-flex justify-content-center">
                  <div className="loader "></div>
                </div>
              ) : (
                <>
                  <div className="p-0 m-0 pb-12">
                    <div className=" bg-gray-10 rounded p-1"></div>
                    {filteredCategories.map((category) => {
                      const catId = String(category.cat_id);
                      const isExpanded = expandedCategories.includes(catId);

                      const itemsToShow = isExpanded
                        ? category.menu_items
                        : category.menu_items.slice(0, 0);

                      // itemsToShow.forEach((item) => {
                      //   if (!availabilityData[item.item_id]) {
                      //     setAvailabilityData((prev) => ({
                      //       ...prev,
                      //       [item.item_id]: {
                      //         homeDelivery: item.homeDeliveryAvailability,
                      //         takeaway: item.takeawayAvailability,
                      //         dineIn: item.diningAvailability,
                      //       },
                      //     }));
                      //   }
                      // });

                      return (
                        <div key={catId}>
                          <div className="d-flex justify-content-between align-items-center my-3">
                            <p
                              className="fw-bold text-dark cursor-pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleCategory(catId)}
                            >
                              {category.category_name?.length > 20
                                ? category.category_name
                                : category.category_name}
                            </p>

                            <div className="d-flex justify-content-end gap-3">
                              <button
                                className="btn btn-sm ms-3 fw-semibold shadow-sm"
                                style={{
                                  backgroundColor: "rgba(1, 195, 125, 1)",
                                  borderColor: "rgba(1, 195, 125, 1)",
                                  color: "white",
                                  transition: "all 0.2s ease-in-out",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(1, 180, 115, 1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(1, 195, 125, 1)";
                                }}
                                onClick={() =>
                                  openCustomizationModal(
                                    catId,
                                    category.customization
                                  )
                                }
                              >
                                Customize
                              </button>
                              {category.menu_items.length > 0 && (
                                <button
                                  className="btn btn-sm px-2 py-1 rounded bg-light text-primary"
                                  onClick={() => toggleCategory(catId)}
                                >
                                  {isExpanded ? (
                                    <img
                                      src={downArrow}
                                      className="img-fluid"
                                      style={{ width: "1rem", height: "1rem" }}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src={rightArrow}
                                      className="img-fluid"
                                      style={{ width: "1rem", height: "1rem" }}
                                      alt=""
                                    />
                                  )}
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="ps-1">
                            {itemsToShow.map((item) => {
                              const hasVariants =
                                Array.isArray(item.prices) && item.prices.length > 1;
                              const firstPrice =
                                Array.isArray(item.prices) &&
                                  item.prices.length > 0
                                  ? item.prices[0]
                                  : {};
                              const visibilitySource =
                                item.visibility ?? firstPrice.visibility;
                              const isVisible =
                                visibilitySource === "Y" ||
                                visibilitySource === true ||
                                visibilitySource === 1 ||
                                visibilitySource === "1";

                              return (
                                <div
                                  key={item.item_id}
                                  id={`cat-item-${item.item_id}`}
                                  className="d-flex align-items-center  py-2 bg-light rounded my-2"
                                >
                                  {/* Image */}
                                  <div
                                    className="flex-shrink-0 ms-2"
                                    style={{
                                      width: "5rem",
                                      height: "5rem",
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <img
                                      src={item.photo}
                                      alt={item.name}
                                      loading="lazy"
                                      decoding="async"
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                  </div>

                                  {/* Text Content */}
                                  <div className="flex-grow-1 text-start ms-3">
                                    <p className="fw-medium mb-1 ">
                                      {item.item_name}
                                    </p>
                                    <div className="d-flex">
                                      <p className="text-muted small mb-0">
                                        {item.prices?.[0]?.formatted_price}

                                      </p>
                                      {item.prices?.[0]?.home_delivery_price && <p className="ps-1 text-muted small mb-0">
                                        {' '}<b>|</b> H.D : ₹{item.prices?.[0]?.home_delivery_price}
                                      </p>}

                                      {item.prices?.[0]?.takeaway_price && <p className="ps-1 text-muted small mb-0">
                                        {' '}<b>|</b> T.A : ₹{item.prices?.[0]?.takeaway_price}
                                      </p>}


                                    </div>

                                  </div>
                                  <div className="d-flex border rounded-5 p-2 pe-3 bg-white align-items-center gap-3 flex-wrap me-2">
                                    {/* Packaging Button */}
                                    {isItemPackagingEnabled && (() => {
                                      const pkg = String(item.packaging_charge || "N").toUpperCase(); // "Y" or "N"
                                      const isOn = pkg === "Y";
                                      const busy = packagingBusyId === String(item.item_id);

                                      return (
                                        <button
                                          className="btn btn-sm d-flex align-items-center justify-content-center"
                                          title={isOn ? "Package Charges: ON" : "Package Charges: OFF"}
                                          disabled={busy}
                                          style={{
                                            backgroundColor: isOn ? "#16a34a" : "#ef4444",
                                            color: "#fff",
                                            width: 34,
                                            height: 34,
                                            borderRadius: "50%",
                                            opacity: busy ? 0.7 : 1,
                                            cursor: busy ? "not-allowed" : "pointer",
                                          }}
                                          onClick={() => {
                                            markAnchor(category.cat_id, item.item_id);
                                            togglePackagingCharge(item);
                                          }}
                                        >
                                          {isOn ? <PackageCheck size={16} /> : <Package size={16} />}
                                        </button>
                                      );
                                    })()}




                                    {/* 👁 View (icon only) */}
                                    <button
                                      className="btn btn-sm d-flex align-items-center justify-content-center"
                                      title="View Item"
                                      style={{
                                        backgroundColor: "#16a34a",
                                        color: "#fff",
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                      }}

                                      onClick={() => {
                                        /* ⛔ unchanged logic */
                                        markAnchor(category.cat_id, item.item_id);
                                        let categoryIdFromItem = "";
                                        try {
                                          categoryIdFromItem =
                                            (JSON.parse(item.category || "[]") || [])[0] || "";
                                        } catch {
                                          categoryIdFromItem = item.category || "";
                                        }

                                        const prices = Array.isArray(item.prices) ? item.prices : [];
                                        const first = prices[0] || {};

                                        const itemWithParent = {
                                          ...item,
                                          parentCategoryId: category.cat_id,
                                          parentCategoryName: category.category_name,
                                        };

                                        setViewModalItem(itemWithParent);

                                        setEditableDetails({
                                          ...itemWithParent,
                                          item_id: item.item_id,
                                          item_name: item.item_name,
                                          category: item.sub_category || categoryIdFromItem,
                                          categoryId: String(category.cat_id || ""),
                                          photo: item.photo || "",
                                          imageUrl: item.photo || "",
                                          selectedPriceIndex: 0,
                                          sizeId: first.size_id || "",
                                          size: first.size || "",
                                          sellingPrice: first.price || "",
                                          homeDeliveryPrice: first.home_delivery_price ?? "",
                                          takewayPrice: first.takeaway_price ?? "",
                                          diningPrice: first.dining_price ?? "",
                                          roomOrderPrice: first.room_order_price ?? "",
                                          carOrderPrice: first.car_order_price ?? "",
                                          taxPercentage: first.item_tax ?? "",
                                          rackNo: item.rackNumber || "",
                                          expiryDate: item.expiryDate || "",
                                          variantId: String(first.variantId || first.size_id || ""),
                                          variantName: first.variantName || first.size || "",
                                          id: first.id || "",
                                        });
                                        setSelectedPrinter(item.printer_alias)
                                        setIsEditingDetails(false);
                                      }}
                                    >
                                      <Eye size={16} />
                                    </button>

                                    {/* ➕ Add Variant (icon only) */}
                                    <button
                                      className="btn btn-sm d-flex align-items-center justify-content-center"
                                      title="Add Variant"
                                      style={{
                                        backgroundColor: "#01C37D",
                                        color: "#fff",
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                      }}
                                      onClick={() => {
                                        setSelectedVariantItem(item);
                                        setShowAddItemVariantModal(true);
                                      }}
                                    >
                                      <Plus size={16} />
                                    </button>

                                    {/* 🧩 Show Variants (only if variants exist) */}
                                    {hasVariants && (
                                      <button
                                        className="btn btn-sm d-flex align-items-center justify-content-center"
                                        title="Manage Variants"
                                        style={{
                                          backgroundColor: "#2563eb",
                                          color: "#fff",
                                          width: 34,
                                          height: 34,
                                          borderRadius: "50%",
                                        }}
                                        onClick={() => {
                                          markAnchor(category.cat_id, item.item_id);
                                          setVariantSVItem(item);
                                          setVariantSVModalOpen(true);
                                        }}
                                      >
                                        <Layers size={16} />
                                      </button>
                                    )}

                                    {/* ✅ Visible checkbox */}
                                    {(
                                      <label className="d-flex align-items-center gap-1 ms-2">
                                        <input
                                          type="checkbox"
                                          checked={isVisible}
                                          onChange={() => {
                                            markAnchor(category.cat_id, item.item_id);
                                            toggleVisibilityStatus(item);
                                          }}
                                        />
                                        <span className="small fw-semibold">Visible</span>
                                      </label>
                                    )}

                                    {/* ✅ Stock checkbox */}
                                    {(
                                      <label className="d-flex align-items-center gap-1 ms-2">
                                        <input
                                          type="checkbox"
                                          checked={item.inStock}
                                          onChange={() => {
                                            markAnchor(category.cat_id, item.item_id);
                                            toggleStockStatus(item);
                                          }}
                                        />
                                        <span className="small fw-semibold">Stock</span>
                                      </label>
                                    )}

                                  </div>


                                </div>
                              );
                            })}
                            <hr className="border-secondary" />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* Customization Modal */}
        <CatalogueCustomizationModal
          show={!!customizationModal}
          onHide={() => setCustomizationModal(false)}
          customizationSets={customizationSets}
          selectedCustomizations={selectedCustomizations}
          setSelectedCustomizations={setSelectedCustomizations}
          onApply={handleCustomizationApply}
        />

        {/* View / Edit Modal */}
        <CatalogueItemModal
          viewModalItem={viewModalItem}
          setViewModalItem={setViewModalItem}
          viewModalTab={viewModalTab}
          setViewModalTab={setViewModalTab}
          editableDetails={editableDetails}
          setEditableDetails={setEditableDetails}
          isEditingDetails={isEditingDetails}
          setIsEditingDetails={setIsEditingDetails}
          handleNumberWheel={handleNumberWheel}
          availabilityData={availabilityData}
          handleCheckboxChange={handleCheckboxChange}
          handleSubmit={handleSubmit}
          printerList={printerList}
          printerLoading={printerLoading}
          fetchPrinterList={fetchPrinterList}
          selectedPrinter={selectedPrinter}
          setSelectedPrinter={setSelectedPrinter}
          setAddPrinterModalOpen={setAddPrinterModalOpen}
          handleSavePrinterToItem={handleSavePrinterToItem}
          navigate={navigate}
          userID={userID}
          baseUrl={baseUrl}
          config={config}
          onItemUpdated={refreshCataloguePreserveScroll}
          variants={variants}                 // 🔹 add
          loadingVariants={loadingVariants}   // 🔹 add
        />

        {/* Add Printer Modal */}
        <AddPrinterModal
          open={addPrinterModalOpen}
          onClose={() => setAddPrinterModalOpen(false)}
          formData={addPrinterFormData}
          onChange={handlePrinterInputChange}
          onSubmit={handleAddPrinterSubmit}
        />

        <VariantManagerModal
          show={isVariantModalOpen}
          onHide={() => setIsVariantModalOpen(false)}
          baseUrl={baseUrl}
          config={config}
          variants={variants}
          loadingVariants={loadingVariants}
          refreshVariants={fetchVariants}
        />
        <AddItemVariantModal
          show={showAddItemVariantModal}
          onHide={() => setShowAddItemVariantModal(false)}
          itemId={selectedVariantItem?.item_id}
          item={selectedVariantItem}
          itemName={selectedVariantItem?.item_name}
          userID={userID}
          baseUrl={baseUrl}
          config={config}
          onSuccess={refreshCataloguePreserveScroll}
        />
        <VariantStockVisibilityModal
          show={variantSVModalOpen}
          onHide={() => {
            setVariantSVModalOpen(false);
            setVariantSVItem(null);
          }}
          item={variantSVItem}
          baseUrl={baseUrl}
          config={config}
          onUpdated={refreshCataloguePreserveScroll}
        />





      </>
    </>
  );
};

export default CatalogueTable;
